module.exports = __webpack_public_path__ + "img/ic-add-blue.b42658bf.svg";